import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7l-5-5H6zm2 14h8v2H8v-2zm8-4H8v2h8v-2z" }));
export default createSvgIcon(iconPath, "File");
//# sourceMappingURL=FileIcon.js.map